// extracted by mini-css-extract-plugin
export var connectionButton = "_bg-1";
export var rightPanel = "_bg-3";
export var stepDescription = "_bg-2";
export var stepIcon = "_bg-0";